var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing-page-&-Service-page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "page-5",
    transform: "translate(-419.000000, -729.000000)",
    fill: "#FFFFFE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin",
    transform: "translate(419.000000, 729.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-67"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    points: "0.3024 15.268 3.4536 15.268 3.4536 5.0896 0.3024 5.0896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8632,3.7568 C2.892,3.7568 3.7264,2.9144 3.7264,1.8776 C3.7264,0.8408 2.892,-5.68434189e-14 1.8632,-5.68434189e-14 C0.8336,-5.68434189e-14 -2.77111667e-13,0.8408 -2.77111667e-13,1.8776 C-2.77111667e-13,2.9144 0.8336,3.7568 1.8632,3.7568",
    id: "Fill-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4904,9.9248 C8.4904,8.4944 9.1488,7.6416 10.4104,7.6416 C11.5688,7.6416 12.1256,8.46 12.1256,9.9248 C12.1256,11.3912 12.1256,15.268 12.1256,15.268 L15.2616,15.268 C15.2616,15.268 15.2616,11.5496 15.2616,8.8232 C15.2616,6.0968 13.716,4.7784 11.5576,4.7784 C9.3984,4.7784 8.4904,6.46 8.4904,6.46 L8.4904,5.0896 L5.468,5.0896 L5.468,15.268 L8.4904,15.268 C8.4904,15.268 8.4904,11.4928 8.4904,9.9248",
    id: "Fill-23"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedin);
export default __webpack_public_path__ + "static/media/social-linkedin.877223b6268dc2dfbcf108bf19a922a8.svg";
export { ForwardRef as ReactComponent };